import {
  FETCH_HYPO_CHART_REQUEST,
  FETCH_HYPO_CHART_SUCCESS,
  FETCH_HYPO_CHART_FAILURE
} from './action-types';
import { internalApiClient } from '../../../services/screener-service';
import { getHypotheticalGrowth } from '../../../hooks/api';
import _ from 'lodash';
import moment from 'moment-msdate';

export const fetchHypoChartRequest = xid => {
  return {
    type: FETCH_HYPO_CHART_REQUEST,
    xid
  };
};

export const fetchHypoChartSuccess = (data, xid) => {
  return {
    type: FETCH_HYPO_CHART_SUCCESS,
    payload: data,
    xid
  };
};

export const fetchHypoChartFailure = (error, xid) => {
  return {
    type: FETCH_HYPO_CHART_FAILURE,
    payload: error,
    xid
  };
};

export const fetchHypoChartData = (xid, yyy, channel, inceptionDate, isCIT) => {
  return (dispatch, getState) => {
    const state = getState();
    const hypoChartData = state.chartReducer.hypoChartData;
    const isLoaded = hypoChartData[xid];
    const momentInception = moment(new Date(inceptionDate));
    const isLessThanTenYearsOld = momentInception.isAfter(moment().subtract(10, 'years'));
    const isLessThanOneYearsOld = momentInception.isAfter(moment().subtract(1, 'years'));
    const timeFrame = isLessThanTenYearsOld ? 'SI' : '10y';

    if (isLessThanOneYearsOld) {
      dispatch(fetchHypoChartFailure('There is not enough data to create a Hypothetical Growth of 10k chart.', xid));
      return;
    }

    if (!isLoaded) {
      internalApiClient(yyy, channel)
        .then(service => {
          const inputs = {
            client: service,
            xid,
            timeFrame,
            isCIT
          };
          dispatch(fetchHypoChartRequest(xid));
          getHypotheticalGrowth(inputs)
            .then(fundsData => {
              const mainFundData = _.get(fundsData, 'funds[0]', {});
              fundsData.endDate = _.get(_.last(mainFundData.growth), 'date');
              fundsData.timeFrame = isLessThanTenYearsOld ? 'Since Inception' : '10 Years';
              dispatch(fetchHypoChartSuccess(fundsData, xid));
            })
            .catch(error => dispatch(fetchHypoChartFailure(error.message, xid)));
        })
        .catch(error => dispatch(fetchHypoChartFailure(error.message, xid)));
    }
  };
};
